<template>
  <auth-template>
    <b-col md="12" sm="8">
      <b-card no-body class="mx-4">
        <b-card-body class="p-4">
          <b-form v-on:submit.prevent="onSubmit">
            <h1>Cadastro</h1><pre>
          </pre>
            <p class="text-muted">Solicitar Cadastro</p>
              <div>
                <b-tabs card pills nav-wrapper-class="w-40">
                <b-tab :active="abaativada" @click="abaativada = !abaativada">
                  <template slot="title">
                    <i class="fa fa-meh-o" aria-hidden="true"></i>
                    {{tabs[0]}}
                  </template>
                  <DadosPessoais v-on:trocarabaativa="trocarAba" v-on:disableaba="mudarEstadoAba" v-on:esconderaba="esconderAbaInstituicao"/>
                </b-tab>
                <b-tab :active="!abaativada" v-if="!esconderInstituicao" :disabled="false"  @click="abaativada = !abaativada">
                  <template slot="title">
                    <i class="fa fa-university" aria-hidden="true"></i>
                    {{tabs[1]}}
                  </template>
                 <DadosInstitucionais v-on:trocarabaativa="trocarAba"/>
                </b-tab>
               </b-tabs>
              </div>
          </b-form>
         </b-card-body>
      </b-card>
    </b-col>
  </auth-template>
</template>

<script>
import AuthTemplate from '@/templates/auth/AuthTemplate'
import DadosPessoais from '@/templates/auth/DadosPessoais'
import DadosInstitucionais from '@/templates/auth/DadosInstitucionais'
import VueSelect from 'vue-select'
import {validationMixin} from 'vuelidate'
import {required, minLength, maxLength, email, sameAs} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'

miniToastr.init()

const formShape = {
  cpf: '',
  rg: '',
  bairro: '',
  complemento: '',
  numero: '',
  date: '',
  orgaoExpeditor: '',
  nome: '',
  telefone: '',
  telefoneFixo: '',
  uf: null,
  municipio: null,
  tipoUsuario: 2,
  email: '',
  senha: '',
  confirmaSenha: '',
  confirmaEmail: ''
}

export default {
  name: 'Cadastro',
  components: {
    AuthTemplate,
    DadosPessoais,
    DadosInstitucionais,
    VueSelect
  },
  mixins: [validationMixin],
  validations: {
    form: {
      cpf: {
        required,
        minLength: minLength(14)
      },
      rg: {
        required,
        maxLength: maxLength(14)
      },
      numero: {
        required,
        maxLength: maxLength(6)
      },
      orgaoExpeditor: {
        required,
        maxLength: maxLength(14)
      },
      bairro: {
        required,
        maxLength: maxLength(25)
      },
      date: {
        required,
        maxLength: maxLength(15)
      },
      nome: {
        required
      },
      telefone: {
        required,
        minLength: minLength(19)
      },
      telefoneFixo: {
        minLength: minLength(18)
      },
      uf: {
        required
      },
      municipio: {
        required
      },
      email: {
        required,
        email
      },
      confirmaEmail: {
        required,
        email,
        sameAsEmail: sameAs('email')
      },
      tipoUsuario: {
        required
      },
      cep: {
        minLength: maxLength(8)
      },
      confirmaSenha: {
        required,
        sameAsSenha: sameAs('senha')
      }
    }
  },
  created () {
    this.$store.dispatch('buscarEstados')
    this.$store.dispatch('buscarTipoUsuarios')
  },
  data () {
    return {
      abaativada: true,
      disableAba: true,
      esconderInstituicao: false,
      form: Object.assign({}, formShape),
      text: 'Declaro, para os devidos fins, que concordo com o armazenamento dos meus dados pessoais para a participação no Projeto Mães Unidas. Ao concordar, eu autorizo que o Ministério da Mulher, da Família e dos Direitos Humanos tenha acesso a eles, para fins estatísticos e para aprimoramento do Projeto.',
      status_aceite: 'not_accepted',
      disabled_cidades: true,
      disable_buttons: false,
      valueAceiteTipoUsuario: false,
      valueAceiteCadastro: false,
      titulo_toast: 'Alerta!',
      options: [
        {value: true}
      ],
      options2: [
        {value: true}
      ],
      alerta_pre_cadastro: false,
      mensagem_pre_cadastro: '',
      tabs: ['Dados Pessoais', 'Dados Institucionais']
    }
  },
  computed: {
    estados () {
      return this.$store.state.estado.listaEstados
    },
    cidades () {
      return this.$store.state.cidade.listaCidadesPorEstado
    },
    listacombo () {
      return this.$store.getters.getListaCombo
    },
    isValid () {
      return !this.$v.form.$anyError
    }
  },
  methods: {
    navigate (route) {
      this.$router.push(route)
    },
    mudarEstadoAba (value) {
      this.disableAba = value
    },
    esconderAbaInstituicao (value) {
      this.esconderInstituicao = value
    },
    trocarAba () {
      this.abaativada = !this.abaativada
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/auth/CadastroExterno.vue